import type { TranslationDict } from "../i18n/en.js";

type TFN = (key: keyof TranslationDict, vars?: Record<string, string | number>) => string;

export function formatDuration(seconds: number | null | undefined): string {
  if (seconds == null || seconds <= 0) return "0:00";
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  if (h > 0) {
    return `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  }
  return `${m}:${String(s).padStart(2, "0")}`;
}

export function relativeTime(iso: string, t?: TFN): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const diff = Date.now() - then;
  const sec = Math.floor(diff / 1000);
  if (sec < 60) return t ? t("time.justNow") : "just now";
  const min = Math.floor(sec / 60);
  if (min < 60) return t ? t(min === 1 ? "time.minuteAgo" : "time.minutesAgo", { n: min }) : `${min} minute${min === 1 ? "" : "s"} ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return t ? t(hr === 1 ? "time.hourAgo" : "time.hoursAgo", { n: hr }) : `${hr} hour${hr === 1 ? "" : "s"} ago`;
  const day = Math.floor(hr / 24);
  if (day < 30) return t ? t(day === 1 ? "time.dayAgo" : "time.daysAgo", { n: day }) : `${day} day${day === 1 ? "" : "s"} ago`;
  const month = Math.floor(day / 30);
  if (month < 12) return t ? t(month === 1 ? "time.monthAgo" : "time.monthsAgo", { n: month }) : `${month} month${month === 1 ? "" : "s"} ago`;
  const year = Math.floor(month / 12);
  return t ? t(year === 1 ? "time.yearAgo" : "time.yearsAgo", { n: year }) : `${year} year${year === 1 ? "" : "s"} ago`;
}

export function monetizationLabel(m: string, t?: TFN): string {
  if (t) {
    const key = `monetization.${m}` as keyof TranslationDict;
    return t(key);
  }
  const MAP: Record<string, string> = {
    free: "Free", sub: "Subscription", svod: "SVOD", tvod: "TVOD", ads: "Ads",
  };
  return MAP[m] ?? m;
}